import AbstractAPI from '@/services/api/AbstractAPI';

export default class AppApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/config');
  }

  getAllowedImageSize() {
    return this.makeRequest('/uploadSize', 'get');
  }
}
